"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFinaliseURL = exports.getUploadURL = exports.getEndpoint = exports.getAxios = void 0;
var axios_1 = __importDefault(require("axios"));
var js_access_token_lib_1 = require("@bynder/js-access-token-lib");
var constants_1 = require("../constants");
var retry_1 = __importDefault(require("./retry"));
/**
 * Get the axios instance. If no instance exists, it will create one.
 * @param isPublic Boolean indicating whether the instance should be public or not.
 * @returns An Axios instance.
 */
var getAxios = function (isPublic) { return __awaiter(void 0, void 0, void 0, function () {
    var instance, jwt, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!!instance) return [3 /*break*/, 6];
                _b.label = 1;
            case 1:
                _b.trys.push([1, 5, , 6]);
                if (!isPublic) return [3 /*break*/, 2];
                instance = axios_1.default.create();
                return [3 /*break*/, 4];
            case 2: return [4 /*yield*/, (0, js_access_token_lib_1.getJWT)()];
            case 3:
                jwt = _b.sent();
                instance = axios_1.default.create({
                    headers: {
                        Authorization: "Bearer ".concat(jwt)
                    }
                });
                _b.label = 4;
            case 4:
                (0, retry_1.default)(instance);
                return [3 /*break*/, 6];
            case 5:
                _a = _b.sent();
                console.error('Error while creating Axios instance');
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/, Promise.resolve(instance)];
        }
    });
}); };
exports.getAxios = getAxios;
/**
 * Get the base endpoint for all requests based on the public setting.
 * @param isPublic Boolean indicating whether the endpoint should be public or not.
 * @returns The base private or public endpoint.
 */
var getEndpoint = function (isPublic) {
    if (isPublic) {
        return constants_1.WRITE_REST_UPLOAD_PUBLIC_ENDPOINT;
    }
    else {
        return constants_1.WRITE_REST_UPLOAD_ENDPOINT;
    }
};
exports.getEndpoint = getEndpoint;
/**
 * Get the chunk upload URL based on chunk information.
 * @param chunk The chunk for which to create an upload URL for.
 * @param isPublic Boolean indicating whether the URL should be public or not.
 * @returns The public or private upload URL for a given chunk.
 */
var getUploadURL = function (chunk, isPublic) {
    var fileId = chunk.fileId, number = chunk.number;
    var endpoint = (0, exports.getEndpoint)(isPublic);
    return "".concat(endpoint, "/").concat(fileId, "/chunk/").concat(number - 1);
};
exports.getUploadURL = getUploadURL;
var getFinaliseURL = function (fileId, isPublic) {
    var endpoint = (0, exports.getEndpoint)(isPublic);
    return "".concat(endpoint, "/").concat(fileId, "/finalise");
};
exports.getFinaliseURL = getFinaliseURL;
//# sourceMappingURL=utils.js.map